import { requestBuilder } from '../../../http/RequestBuilder';

interface UseCreateExternalAccountNewBody {
    stytchId: string;
    publicToken: string;
}

interface UseCreateExternalAccountNewResponse {
    success: boolean;
    review?: boolean;
}

const useCreateExternalAccountNew = requestBuilder.mutation<
    UseCreateExternalAccountNewResponse,
    UseCreateExternalAccountNewBody
>({
    endpoint: '/api/external-account/create-new',
    method: 'POST',
});

export default useCreateExternalAccountNew;
